import Store from 'lightningjs-redux';
import { getPairingUid } from '../../../../logic/user/user.selectors';
import { getPremiumServices } from '../../../../logic/pairing/pairing.selectors';
import { getRequestedEntityId, getRequestedEntityType } from '../../../../logic/layout/layout.selectors';
import { getDeviceBrand } from '../../../../logic/app/app.selectors';

const mapControllers = instance => [
  {
    shouldBeInvokedOnConnect: true,
    selector: getPairingUid,
    callback: value => {
      instance.isPaired = Boolean(value);
    },
  },
  {
    shouldBeInvokedOnConnect: true,
    selector: getPremiumServices,
    callback: value => {
      instance.services = value;
    },
  },
  {
    shouldBeInvokedOnConnect: true,
    selector: getRequestedEntityType,
    callback: value => {
      instance.entityType = value;
    },
  },
  {
    shouldBeInvokedOnConnect: true,
    selector: getRequestedEntityId,
    callback: value => {
      instance.entityId = value;
    },
  },
  {
    shouldBeInvokedOnConnect: true,
    selector: getDeviceBrand,
    callback: value => {
      instance.deviceBrand = value;
    },
  },
];

export default Store.control(mapControllers);
